import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0;
  padding: 24px 2px;
  background: ${(props: any) => props.theme.colors.cf8f9fa};
  min-height: 100vh;
  border-radius: 0;

  @media (min-width: 768px) {
    padding: 32px 2px;
  }

  @media (min-width: 1200px) {
    padding: 32px 2px;
  }
`;
